import { Flex } from 'foundations-components/components/Flex';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PrettyPrintJson } from './blocks/PrettyPrintJson';
import { jsx as _jsx } from "react/jsx-runtime";
function parseEntryValue(value) {
  try {
    return JSON.parse(value);
  } catch (_unused) {
    return value;
  }
}
function buildParsedData(context) {
  const result = {};
  for (const entry of context.entries) {
    result[entry.key] = parseEntryValue(entry.value);
  }
  return result;
}
export function MessageContextDetails({
  context
}) {
  const parsedData = buildParsedData(context);
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "message-context-details",
    flexDirection: "column",
    alignItems: "end",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(Flex, {
      maxInlineSize: "min(700px, 100%)",
      inlineSize: "fit-content",
      children: /*#__PURE__*/_jsx(AccordionItem, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "breezeEngineChatComponents.context.title",
          options: {
            count: context.entries.length
          }
        }),
        children: /*#__PURE__*/_jsx(PrettyPrintJson, {
          data: parsedData,
          defaultOpen: true
        })
      })
    })
  });
}